<template>
  <div class="searchtab">
    <div class="wrap">
      <el-tabs type="border-card" v-model="searchTabActiveName" @tab-click="changeTab" :before-leave='leaveTab' :stretch='true'>
        <el-tab-pane :label="$t('T_SEARCH_MODEL')" id="Search" name="Search" v-if="functionEnable('Search')">
          <SearchProjectorTab ref="SearchProjectorTab"></SearchProjectorTab>
        </el-tab-pane>
        <!-- 该组件有初始化相关操作 直接隐藏会有问题 -->
        <SearchProjectorTab ref="SearchProjectorTab" v-if="!functionEnable('Search')" v-show="false"></SearchProjectorTab>

        <el-tab-pane :label="$t('T_SEARCH_CATEGORY')" id="Categolies" name="Categolies" v-if="functionEnable('Categolies')">
          <CategoryTab :searchTabActiveName="searchTabActiveName"></CategoryTab>
        </el-tab-pane>
        <!-- 以下勿删 phase2 要用 -->
        <el-tab-pane :label="$t('T_SEARCH_SPEC')" id="Specification" name="Specification" v-if="functionEnable('Specification')">
          <specification></specification>
        </el-tab-pane>
        <el-tab-pane :label="$t('T_SEARCH_CONDITION')" id="InstallCondition" name="InstallCondition" v-if="functionEnable('InstallCondition')">
          <InstallCondition></InstallCondition>
        </el-tab-pane>
        <el-tab-pane :label="$t('T_CURVE_SURFACE')" id="CurvedSurface" name="CurvedSurface" v-if="functionEnable('CurvedSurface')">
          <SearchProjectorTabByCurved ref="CurvedSurfaceTab"></SearchProjectorTabByCurved>
        </el-tab-pane>
        <el-tab-pane :label="$t('T_EDGE_BLENDING')" id="Blending" name="Blending" v-if="functionEnable('Blending')">
          <EdgeBlending></EdgeBlending>
        </el-tab-pane>
        <div class="search-tab_data seach-content" v-if="searchTabActive !== 'Blending'">
          <el-form :model="inputForm" ref="inputForm" @submit.native.prevent class="search-form" style="padding: 0;padding-bottom: 10px;border-right:none;" v-if="searchTabActive === 'Specification' || searchTabActive === 'InstallCondition'">
            <el-form-item :label="$t('T_SEARCH_RESULT') + ':'" class="search-result-item">
              <span>{{ matchingModelData.length }}</span>
              <span v-if="matchingModelData.length === 1 || matchingModelData.length === 0">{{$t('T_RESULT')}}</span>
              <span v-else>{{$t('')}}</span>
            </el-form-item>
            <el-form-item>
              <el-select style="width: 260px;" v-model="inputForm.selectedModel" @change="onModelChange" :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')">
                <el-option v-for="item in matchingModelDataSort" :key="item.value" :value="item.name" :label="getModelLabel(item.name)" />
                <p slot="empty" class="el-select-dropdown__empty">{{ $t('T_NO_DATA') }}</p>
              </el-select>
            </el-form-item>
          </el-form>
          <el-row>
            <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
              <SearchProjectorResult :searchTabActiveName="searchTabActiveName"></SearchProjectorResult>
            </el-col>
            <el-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11">
              <ComparisonLens :searchTabActiveName="searchTabActiveName"></ComparisonLens>
            </el-col>
            <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1">
              <UserSaveHistory></UserSaveHistory>
            </el-col>
          </el-row>
        </div>
        <div class="cover" v-show="fromBlending && searchTabActive === 'Search'"></div>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import SearchProjectorTab from '@/view/searchTabs/tabs/searchProjectorTab'
import SearchProjectorTabByCurved from '@/view/searchTabs/tabs/searchProjectorTabByCurved'
import CategoryTab from '@/view/searchTabs/tabs/categoryTab'
import SearchProjectorResult from '@/view/searchTabs/searchProjectorResult'
import ComparisonLens from '../view/searchTabs/comparisonLens'
import specification from '../view/searchTabs/specification'
import InstallCondition from '../view/searchTabs/installCondition'
import EdgeBlending from '../view/searchTabs/edgeBlending'
import UserSaveHistory from '../view/searchTabs/userSaveHistory'
import { mapState, mapMutations } from 'vuex'
import { gaEvent, getLangKey } from '../common/ga'// GA追加

export default {
  name: 'searchTab',
  components: {
    SearchProjectorTab,
    SearchProjectorTabByCurved,
    CategoryTab,
    SearchProjectorResult,
    ComparisonLens,
    specification,
    InstallCondition,
    EdgeBlending,
    UserSaveHistory
  },
  data () {
    return {
      inputForm: {
        selectedModel: ''
      }
    }
  },
  mounted () {
    // initMain = 0 进入top页面, initMain = 1 进入index画面
    if (this.InitConfig.initMain === 1) {
      return this.SET_SEARCHTABACTIVE(this.InitConfig.initSearchTab)
    }
  },
  methods: {
    ...mapMutations([
      'SET_SEARCHTABACTIVE',
      'SET_FROMBLENDING',
      'SET_TABACTIVENAME',
      'SET_ISSIMPLE'
    ]),

    onModelChange (value) {
      this.$refs.SearchProjectorTab.onModelChange(value)
    },

    changeTab (value) {
      if (this.searchTabActiveName !== 'Blending' && this.fromBlending) {
        this.SET_FROMBLENDING(false)
      }
    },
    leaveTab (active, oldActive) {
      // basic模式下 点击blending tab 跳到advance模式
      if (this.tabActiveName === 'Basic' && (active === 'CurvedSurface' || active === 'Blending')) {
        this.$commonJs.SimpleDisable()
        this.$router.push('/page/advanceMode')
        this.SET_ISSIMPLE(false)
        this.SET_TABACTIVENAME('Advanced')
        // GA追加：mode变了,走mode变更的监听
        sessionStorage.setItem('mode', 'Advanced mode') // 国际化对应备份：this.$t('T_ADVANCED_MODE')
        sessionStorage.setItem('tab', getLangKey(active)) // 国际化对应备份：this.$t(getLangKey(active))
        return
        // GA追加：mode变了,走mode变更的监听
      }
      // GA追加：切换tab的场合设定
      sessionStorage.setItem('tab', getLangKey(active)) // 国际化对应备份：this.$t(getLangKey(active))
      gaEvent({action: 'page_view'})
      // GA追加：切换tab的场合设定
    },
    functionEnable (value) {
      return this.InitConfig.initFunction.indexOf(value) !== -1
    },
    getModelLabel (label) {
      const parts = label.split('_')
      parts.pop()
      return parts.join('_')
    }
  },
  computed: {
    ...mapState([
      'selectedModelData',
      'searchTabActive',
      'matchingModelData',
      'fromBlending',
      'tabActiveName'
    ]),

    matchingModelDataSort () {
      return this.$commonJs.dataSort(this.matchingModelData, 'name')
    },

    searchTabActiveName: {
      get () {
        return this.searchTabActive
      },
      set (val) {
        return this.SET_SEARCHTABACTIVE(val)
      }
    }
  },

  watch: {
    matchingModelDataSort (newValue) {
      if ((this.searchTabActive === 'Specification' || this.searchTabActive === 'InstallCondition')) {
        if (newValue.length > 0 && this.inputForm.selectedModel) {
          this.inputForm.selectedModel = newValue[0].name
          this.$refs.SearchProjectorTab.onModelChange(newValue[0].name)
        } else if (newValue.length === 0) {
          this.inputForm.selectedModel = ''
        }
      }
    }
  }
}
</script>

<style scoped>
.searchtab {
  padding: 20px 0px;
  position: relative;
}

.cover {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 111;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/searchTab.vue